import { ExpandingTooltip } from "./ExpandingTooltip";

export {
  DlfRequireAllLabel as TTDlfRequireAllLabel,
  AddRule as TTAddRule,
  DeleteRule as TTDeleteRule,
  TestRule as TTTestRule,
  TableRequireAllLabel as TTTableRequireAllLabel,
};

// Item 94
const DlfRequireAllLabel: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Check this box if all validation rules must fire for the extracted data,
        for this template, to be considered valid.
      </p>
    );
  return (
    <>
      <p>
        If this box is checked, all the extracted data must comply to all the
        validation rules, or the field will be invalid for this template and the
        document will stop in Transact for the field to be reviewed. If
        validation rules have been set for a field or column at the Document
        Type level, then any rules set at the template level for those fields or
        columns will replace the rules inherited from the Document Type
        configuration.
      </p>
    </>
  );
};

// Item 95
const AddRule: ExpandingTooltip = (short) => {
  if (short) return <p>Add a new validation rule.</p>;
  return (
    <>
      <p>
        Once you have configured a validation rule, you can add more rules by
        clicking the Add Rule button.
      </p>
    </>
  );
};

// Item 96
const DeleteRule: ExpandingTooltip = () => {
  return <p>Delete this rule </p>;
};

// Item 97
const TestRule: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Test the validation rule(s) against extracted data (only when editing in
        Accelerator) or your own test data.
      </p>
    );
  return (
    <>
      <p>
        Once you have added one or more validation rules, you can test the rules
        against the extracted data if you are configuring a template in
        Accelerator. When configuring in Template Management you cannot view
        extracted data. In Accelerator, you can replace any extracted data with
        test data. Click the <strong>Test Rules</strong> button to run the
        validation rules against the extracted or manually entered data.
      </p>
    </>
  );
};

// Item A2
const TableRequireAllLabel: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Check this box if all validation rules must fire for the extracted data,
        for this template, to be considered valid.
      </p>
    );
  return (
    <>
      <p>
        If this box is checked, all the extracted data must comply to all the
        validation rules, or the column will be invalid for this template and
        the document will stop in Transact for the column to be reviewed.
        Invalid columns will highlight purple when viewing the extracted table.
      </p>
      <p>
        If validation rules have been set for a field or column at the Document
        Type level, then any rules set at the template level for those fields or
        columns will replace the rules inherited from the Document Type
        configuration.
      </p>
    </>
  );
};
